(function () {
  var events = ['mousemove', 'scroll', 'pointerdown', 'keydown', 'touchstart'];
  function load() {
    events.forEach(function (name) {
      window.removeEventListener(name, load);
    });
    (function (u, c, o, i, s, l, b) {
      window['ClientbookWebChatObject'] = { u: u, c: c, w: o, i: i, s: s, l: l, b: b };
      var ga = document.createElement('script');
      ga.type = 'text/javascript';
      ga.async = true;
      ga.src = 'https://webchat.clientbook.com/wc.min.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(ga, s);
    })('9ba66988-1b7d-4525-88e5-214a760f8041', '', '', 'https://s3.amazonaws.com/images.giftry.com/partner/jonesbrosAvatar.png');
  }
  events.forEach(function (name) {
    window.addEventListener(name, load, { passive: true });
  });
})();

new MutationObserver(function () {
  var widget = document.getElementById('clbkwc_chat_id');
  if (widget)
    widget.querySelectorAll('img:not([alt])').forEach(function (img) {
      img.alt = '';
    });
  document.querySelectorAll('button[id^="clbkwc_"]:not([aria-label])').forEach(function (btn) {
    btn.setAttribute('aria-label', 'Open chat');
  });
}).observe(document.body, { childList: true, subtree: true });
